import { useEffect, useState } from "react";
import VideoPlayer from "react-video-js-player";
import { videoEvents } from "../../../../utils/VideoClickStream";
import _ from "lodash";
import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import { videoExtensionType } from "../../../../utils/AppUtils";

const TeaserBannerComponent = ({ productId, videoLink, videoLinkType }) => {
  const [videoType, setVideoType] = useState("");
  const [extension, setExtension] = useState("mp4");

  useEffect(() => {
    if (videoLink) {
      console.log("VIDEO LINK", videoLink);
      const typeSplit = videoLink.includes(".") ? videoLink.split(".") : [];
      const extension = typeSplit[typeSplit.length - 1];
      if (videoLink.includes("youtube.com")) {
        setVideoType("youtube");
        let ytID = videoLink
          ?.split("https://www.youtube.com/embed")[1]
          ?.split("title")[0]
          ?.replace('" ', "")
          ?.replace("/", "");
        console.log("YTID", ytID);
        setTimeout(() => floaded(ytID), 2000);
      } else if (["m3u8", "mp4", "mkv", "webm", "avi"].includes(extension)) {
        setExtension(videoExtensionType(extension));
        setTimeout(() => setVideoType("player"), 0);
      } else {
        setVideoType(videoLinkType);
      }
    }
  }, [videoLink]);

  const videoCompleted = () => {};

  const floaded = (ytID) => {
    console.log("YOUTUBE ID", ytID, videoType);
    try {
      let players = new window.YT.Player("youtube-player", {
        height: "70%",
        width: "100%",
        videoId: ytID,
        playerVars: {
          autoplay: 1, // Auto-play the video on load
          controls: 0, // Show pause/play buttons in player
          showinfo: 0,
          rel: 0,
          // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          loop: 1, // Run the video in a loop
          fs: 0, // Hide the full screen button
          cc_load_policy: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 0, // Hide video controls when playing
        },

        events: {
          onPlayerReady: (e) => {
            console.log("Event Ready", e);
          },
          onStateChange: (e) => {
            console.log("State Change", e);
            if (e.data === 0) {
              videoCompleted();
            }
          },
        },
      });
      console.log(players);
    } catch (error) {
      console.log(error);
    }
  };
  const [isLoading, setIsLoading] = useState(true);

  const onPlayerReady = (player) => {
   
    player.src("");
    player.src(videoLink);
    const trackEl = player.addRemoteTextTrack(
      {
        src: "",
        kind: "captions",
        srclang: "en",
        label: "English",
      },
      false
    );
    trackEl.addEventListener("load", function () {
      // your callback goes here
    });
    videoEvents(player, {
      type: "video",
      video_id: _.toNumber(productId),
    });
    player.on("ended", () => {
      videoCompleted();
    });
    setIsLoading(false);
  };

  const renderPlayer = () => {
    if (videoType === "youtube") {
      return <div id="youtube-player"></div>;
    } else if (videoType === "embed") {
      return (
        <div
          className="video-full"
          id="player"
          dangerouslySetInnerHTML={{
            __html: videoLink,
          }}
        ></div>
      );
    } else if (videoType === "player") {
      return (
        <div className="video-full">
          {isLoading && (
            <div className="container">
              <ShimmerScreen
                case="rect"
                width="100%"
                height="65vh"
                borderRadius="10px"
              />
            </div>
          )}
          <div
            className=""
            style={{
              visibility: isLoading ? "hidden" : "visible",
              height: isLoading ? "0px" : "unset",
            }}
          >
            <VideoPlayer
              className="img-videosec learn_image-card"
              controls={true}
              // src="https://cdn-stg.niit-mts.com/xsel/media/sample-20s.m3u8"
              // src="https://cdn-stg.niit-mts.com/xsel/media/9cbddd10-ee5f-4972-a5da-11dfde71fcff.m3u8"
              src={videoLink}
              width="100%"
              height="65vh"
              autoPictureInPicture={true}
              poster={""}
              fluid={true}
              inline={false}
              pictureInPictureToggle={true}
              type={extension}
              onReady={onPlayerReady}
              crossorigin="use-credentials"
            />
          </div>
        </div>
      );
    } else {
      return (
        <>
          <iframe
            className="w-1000"
            id="scorm_player"
            // height={"65vh"}
            title={"video_player"}
            style={{
              // minHeight: "65vh",
              width: "100%",
              margin: "0 auto",
            }}
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            src={videoLink.replace("\\", "")}
            allowFullScreen={true}
            // onLoad={() => floaded()}
          />
          <div id="scorm_player"></div>
        </>
      );
    }
  };

  return (
    <>
      <div className="video-full-banner">{renderPlayer()}</div>
    </>
  );
};

export default TeaserBannerComponent;
